import { Text, Card } from '@/components'
import { DollarSign } from 'react-feather'
import { RewardRow } from './RewardRow'
import ReminderModal from '../components/reminderModal'
import { ActivityViewModelProps } from './Activity.viewmodel'
import { pointsToDollars } from '../../rewards.utils'
import { IconContainer } from '../components/IconContainer'

export const PendingTransactionsCard = (props: ActivityViewModelProps) => {
  if (!props.pendingTransactions.length && !props.pendingReferrals.length)
    return null

  return (
    <Card className="w-full">
      <div className="w-full flex justify-start flex-col">
        <Text variant="h3">Pending</Text>
        <div className="w-full flex flex-col items-center divide-y divide-solid divide-gray-200">
          {props.pendingReferrals.map((referral) => (
            <RewardRow
              icon={
                <div className="w-8 h-8 flex items-center justify-center bg-purple-50 p-[6px] rounded-lg">
                  <Text className="text-sm font-semibold text-purple-600">
                    {referral.referred_name?.[0] ?? 'U'}
                  </Text>
                </div>
              }
              label={referral.referred_name ?? 'Unnamed Referral'}
              description={`Needs to connect their Vehicle`}
              key={referral.id}
              onClick={() => props.sendReminder(referral)}
              label2={
                <Text
                  className={`text-sm font-medium underline cursor-pointer ${
                    referral.can_remind ? 'text-gray-900' : 'text-gray-300'
                  }`}
                  onClick={(e) => {
                    e?.stopPropagation()
                    props.sendReminder(referral)
                  }}
                >
                  Remind
                </Text>
              }
            />
          ))}
          {props.pendingTransactions.map((transaction) => (
            <RewardRow
              icon={
                <IconContainer
                  icon={DollarSign}
                  bgColor="bg-orange-100"
                  textColor="text-orange-500"
                />
              }
              label="Reward redemption"
              description="Redeem your reward"
              key={transaction.id}
              onClick={() => {
                props.openTremendousModal(transaction)
              }}
              label2={
                <div className="flex flex-col items-end gap-1">
                  <Text className="text-sm font-bold text-gray-400">
                    +${pointsToDollars(Math.abs(transaction.points))}
                  </Text>
                  <Text
                    onClick={(e) => {
                      e?.stopPropagation()
                      props.openTremendousModal(transaction)
                    }}
                    className="text-sm font-bold text-blue-600 underline cursor-pointer"
                  >
                    Redeem
                  </Text>
                </div>
              }
            />
          ))}
        </div>
        <ReminderModal
          open={props.reminderModalOpen}
          onClose={props.onReminderClose}
        />
      </div>
    </Card>
  )
}
